<script lang="ts">
	import { Token } from '@Shelly/shelly-design-system';
	import { getDevicesCurrentApplianceTypes } from 'src/helpers/device_settings_helpers';
	import { deepCopy } from 'src/helpers/utilities';
	import { devicesFiltersInitialState } from 'src/stores/ui/filters';
	import type { FilterOption } from 'src/stores/ui/filters';

	export let appliedFilters;
	export let toggleFilterOptions;

	let filterOptions: FilterOption[] = getDevicesCurrentApplianceTypes()
		.map((type) => {
			return {
				id: type.value,
				title: type.title,
				translationDefault: type.title,
				selected: type.selected,
			};
		})
		.map((option) => {
			const storeOption = appliedFilters.appliance_types.find(
				(filter) => filter?.id === option?.id,
			);
			option.selected = storeOption?.selected;
			return option;
		});

	const handleSelectFilter = (option) => {
		appliedFilters.appliance_types = appliedFilters.appliance_types.map((filter) => {
			if (filter.id === option.id) {
				filter.selected = !filter.selected;
				return filter;
			}
			return filter;
		});

		filterOptions = toggleFilterOptions(filterOptions, option);
	};

	const resetData = () => {
		appliedFilters.appliance_types = deepCopy(devicesFiltersInitialState.appliance_types);

		filterOptions = filterOptions.map((filter) => {
			return {
				...filter,
				selected: false,
			};
		});
	};
</script>

<svelte:window on:reset={resetData} />

<div class="d-flex flex-wrap" style="gap: 8px;">
	{#each filterOptions as option}
		<Token
			id="token-me1eszm"
			size="m"
			title={option.title}
			on:click={() => handleSelectFilter(option)}
			selected={option.selected}
		/>
	{/each}
</div>
